module.exports = __webpack_public_path__ + "img/compresor-2.8a2a40fe.png";